/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react'
import {KTSVG, toAbsoluteUrl} from '../../../../../_metronic/helpers'
//import { PermissionAddModal } from './PermissionAddModal'
import { propTypes } from 'react-bootstrap/esm/Image';
import { OrganizationAddModal } from './OrganizationAddModal';
import {Link} from 'react-router-dom'

type Props = {
  className : string,
  orgns : any,
  getAllOrgns : any
}

const OrganizationTable: React.FC<Props> = ({className, orgns, getAllOrgns}) => {

    const [showModal, setShowModal] = useState(false);
    const [data, setData] = useState(null);
    const [edit, setEdit] = useState(false);

    const toggleShow = (organizationId:any)  => {
        
        setEdit(false);
        if(organizationId !== 0){
          setEdit(true);
          orgns.map((organization:any)=> {
            if(organizationId === organization.id){
              setData(organization);
            }
          });
        
        }

        setShowModal(pre => !pre);

        if(showModal){
          console.log('toggleShow ' + organizationId);
          getAllOrgns();
        }
    }

    const deleteOrganization = async (organizationId:any) => {
      //delete organization
      try
      {
        await fetch(process.env.REACT_APP_API_URL_BACKEND + '/organization/', 
        {
          method: 'DELETE',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({'organization_id': organizationId})
        });
        
        getAllOrgns();
      }
      catch(error)
      {
        console.log(error);
      }

    }

  return (
    <>
    <div className={`card ${className}`}>
      {/* begin::Header */}
      <div className='card-header border-0 pt-5'>
        <h3 className='card-title align-items-start flex-column'>
          <span className='card-label fw-bold fs-3 mb-1'>Organizations </span>
        </h3>
        <div className='card-toolbar'>
          <button onClick={() => toggleShow(0)} className='btn btn-sm btn-light-primary'>
            <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-2' />
            Add Organization
          </button>
        </div>
      </div>
      {/* end::Header */}
      {/* begin::Body */}
      <div className='card-body py-3'>
        {/* begin::Table container */}
        <div className='table-responsive'>
          {/* begin::Table */}
          <table className='table align-middle gs-0 gy-4'>
            {/* begin::Table head */}
            <thead>
              <tr className='fw-bold text-muted bg-light'>
                <th className='ps-4 min-w-100px rounded-start'>Logo</th>
                <th className='ps-4 min-w-325px rounded-start'>Name</th>
                <th className='ps-4 min-w-125px rounded-start'>Branches</th>
                <th className='ps-4 min-w-125px rounded-start'>Status</th>
                <th className='min-w-200px text-end rounded-end'></th>
              </tr>
            </thead>
            {/* end::Table head */}
            {/* begin::Table body */}
            <tbody>
                {orgns.map((organization:any) => (
                    <tr key={`organization-${organization.id}`}>
                        <td>
                          <div className="rounded h-50px me-5">
                            <img src={organization.logo} className="h-50px" />
                          </div>
                        </td>
                        
                        <td>
                          <span className='text-dark fw-bold mb-1 fs-6'>
                            {organization.name}
                          </span>
                        </td>
                        <td><span className='text-dark fw-bold mb-1 fs-6'>{organization.branches_count} / {organization.branch_limit}</span></td>
                        <td><span className='text-dark fw-bold mb-1 fs-6'>{organization.status === 1 ? 'Active':'In-Active'}</span></td>
                        <td className='text-end'>
                            <Link to={`/organizations/${organization.id}/branches`} >
                              <span className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'>
                                <KTSVG path='/media/icons/duotune/abstract/abs029.svg' className='svg-icon-3' />
                              </span>
                            </Link>

                            <a href='#' onClick={() => toggleShow(organization.id)} className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'>
                            <KTSVG path='/media/icons/duotune/art/art005.svg' className='svg-icon-3' />
                            </a>
                            
                            <a href='#' onClick={() => deleteOrganization(organization.id)} className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'>
                            <KTSVG path='/media/icons/duotune/general/gen027.svg' className='svg-icon-3' />
                            </a>
                        </td>
                    </tr>
                )
                )}


            </tbody>
            {/* end::Table body */}
          </table>
          {/* end::Table */}
        </div>
        {/* end::Table container */}
      </div>
      {/* begin::Body */}
    </div>
    {
        showModal ? <OrganizationAddModal toggleShow={toggleShow} isUpdate={edit} itemToEdit={data} /> : null
    }
    </>
  )
}

export {OrganizationTable}
